import { z } from 'zod';

import { WhatsNewEntryType } from './whats-new-entry-type';

export type CreateWhatsNewEntryPayload = z.infer<typeof createWhatsNewEntryPayloadSchema>;

export const createWhatsNewEntryPayloadSchema = z.object({
  title: z.string(),
  subtitle: z.string().max(100),
  message: z.string(),
  link: z.url().nullable(),
  linkTitle: z.string().nullable(),
  type: z.enum(WhatsNewEntryType),
});
